<h2 mat-dialog-title class="dialog-title-custom">Website-Einstellungen</h2>
<mat-dialog-content class="tabs-container">
    <mat-tab-group mat-stretch-tabs="true" dynamicHeight (selectedTabChange)="onTabChanged($event)">

        <mat-tab label="Seitenverwaltung">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Welche Seiten werden benötigt?</h2>
                    <p class="admin-text">
                        Die Unterseiten Ihrer Website können Sie hier verwalten. Klicken Sie dazu auf eine Unterseite, um die
                        Einstellungen zu bearbeiten bzw. um Unterseiten hinzuzufügen oder zu entfernen. Gruppen geben Ihnen die Möglichkeit, 
                        mehrere Unterseiten zu einer Gruppe zusammenzufassen und als Menüpunkt in der Navigation anzuzeigen.
                    </p>
                    <app-website-config-form-page-administration></app-website-config-form-page-administration>
                </div>
            </ng-template>
        </mat-tab>

        <!-- TODO: SVI - See problem of unnecessary data loading -->
        <!-- <mat-tab label="Öffnungszeiten">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Wann ist Ihr Geschäft geöffnet?</h2>

                    <p class="admin-text italic">
                        Neben den regulären Öffnungszeiten können Sie auch spezielle Öffnungszeiten für Feiertage oder andere
                        besondere Anlässe, wie Urlaube, festlegen. Diese werden dann anstelle der regulären Öffnungszeiten angezeigt. Darüber hinaus erscheint
                        auf Ihrer Website vor unregelmäßigen Öffnungszeiten ein Hinweis, dass die Öffnungszeiten abweichen können.
                    </p>
                </div>
                <app-website-config-form-opening-hours></app-website-config-form-opening-hours>
            </ng-template>
        </mat-tab> -->

        <mat-tab label="Styling">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Wie soll Ihre Website aussehen?</h2>
                    <p class="admin-text italic">
                        Hier können Sie das Design Ihrer Website anpassen. Wählen Sie aus verschiedenen Farbschemata und
                        Schriftarten. Ein eigenes Logo für die App können Sie im Reiter App hochladen.                        
                    </p>
                </div>
                <app-website-config-form-styling></app-website-config-form-styling>
            </ng-template>
        </mat-tab>

        <mat-tab label="Kontaktdaten">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Wie können Kunden mit Ihnen in Kontakt treten?</h2>
                    <p class="admin-text italic">
                        Hier können Sie Ihre Kontaktdaten eintragen. Diese werden auf Ihrer Website angezeigt, damit Ihre
                        Kunden Sie besser erreichen können. Zusätzlich können Sie auch eine E-Mail Adresse hinterlegen, an die Sie Anfragen
                        über das Kontaktformular auf Ihrer Website erhalten möchten.
                    </p>
                </div>

                <app-website-config-form-contact-data></app-website-config-form-contact-data>
            </ng-template>
        </mat-tab>

        <!-- TODO: SVI - See problem of unnecessary data loading -->
        <mat-tab label="Rechtliches">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Erstellen Sie Impressum und Datenschutz!</h2>
                    <p class="admin-text italic">
                        Hier können Sie Ihr Impressum und Ihre Datenschutzerklärung eintragen. Zur Erstellung können Sie
                        die Vorlagen nutzen oder eigene Texte verfassen, die dann auf Ihrer Website angezeigt werden. Bitte beachten Sie, dass
                        die Vorlagen lediglich als Hilfestellung gedacht sind, aber keine Rechtsberatung ersetzen oder garantieren, dass Ihre Website
                        den gesetzlichen Anforderungen entspricht.
                    </p>
                </div>
                <app-website-config-form-legal-notice></app-website-config-form-legal-notice>
            </ng-template>
        </mat-tab>

        <mat-tab label="Bewertungen">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Google-Bewertungen</h2>
                    <p class="admin-text italic">Fügen Sie Ihrer Website Google-Bewertungen hinzu, um das Vertrauen
                        Ihrer Kunden zu stärken. Über die Ansicht "Bewertungen ansehen" können Sie Bewertungen
                        hinzufügen oder
                        entfernen. Über die Ansicht "Bewertungen ordnen" lässt sich die Reihenfolge der Bewertungen auf
                        Ihrer Website festlegen.</p>
                    <app-website-config-reviews></app-website-config-reviews>
                </div>
            </ng-template>
        </mat-tab>


        <mat-tab label="Apps">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">App-Icon</h2>
                    <p class="admin-text italic">An dieser Stelle haben Sie die Möglichkeit, das Icon Ihrer App zu
                        ändern. Dieses Icon wird Ihren Nutzern angezeigt, wenn sie die App auf ihrem Smartphone
                        installieren aber auch
                        im Browser-Tab, wenn sie Ihre Website im Browser öffnen. Bitte beachten Sie, dass das Icon
                        quadratisch sein sollte.</p>
                    <app-website-config-form-app-management></app-website-config-form-app-management>
                    
                    <mat-divider></mat-divider>
                    <br>
                    <h2 class="admin-subsubheader">Widgets</h2>
                    <p class="admin-text italic">In diesem Abschnitt können Sie Ihrer Website Widgets hinzufügen und diese konfigurieren. Widgets sind kleine
                        Anwendungen, die auf Ihrer Website eingebettet werden können und Ihren Kunden zusätzliche Funktionen bieten.</p>
                    <app-widget-quick-action></app-widget-quick-action>
                </div>
            </ng-template>
        </mat-tab>

        <mat-tab label="Social Media & Partner">
            <ng-template matTabContent>
                <div class="tab-content">
                    <h2 class="admin-subsubheader">Wollen Sie Social Media- & Partnerseiten verlinken?</h2>
                    <p class="admin-text">
                        Fügen Sie hier Ihre Social Media Profile und Partnerseiten hinzu, um diese im Footer Ihrer Website zu verlinken. Die Links werden in einem neuen Tab geöffnet und sind nicht originärer Bestandteil Ihrer Website. Optional können Sie Partnerlinks eine Beschreibung hinzufügen, die als Linktext angezeigt wird. Ohne Beschreibung wird die URL als Linktext verwendet. Ihre Social Media Accounts hingegen werden mit den gängigen Platform Icons dargestellt.
                    </p>
                    <app-website-config-form-social-media></app-website-config-form-social-media>
                    <app-website-config-form-partner></app-website-config-form-partner>
                </div>
            </ng-template>
        </mat-tab>

        <!-- <mat-tab aria-label="Stripe">
            <ng-template mat-tab-label>
                <div class="tab-icon">
                    <mat-icon>shopping_cart</mat-icon>
                </div>
            </ng-template>
            <ng-template matTabContent>
                <div class="tab-content">
                    <app-stripe-pricing-table></app-stripe-pricing-table>
                </div>
            </ng-template>
        </mat-tab> -->
    </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="cancel()">Verwerfen</button>
    <button mat-button (click)="saveChanges()">Übernehmen</button>
</mat-dialog-actions>